import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import LoadingSVG from '../svg/loading.svg';

import Paragraph from './renderers/Paragraph';
import Button from './Button';
import { FormError, FormInput, FormTextarea } from './form';
import useSendData from '../hooks/useSendData';

const FeedbackForm = ({ href = '' }) => {
  const {
    sendData,
    state: { error: feedbackError, result: feedbackResult },
  } = useSendData({ endpoint: '/api/create-feedback-notification' });
  const methods = useForm({
    defaultValues: {
      href,
    },
  });
  const {
    formState: { isSubmitting },
    handleSubmit,
  } = methods;

  const onSubmit = async (values) => await sendData(values);

  if (feedbackResult) return <Paragraph>{feedbackResult.message}</Paragraph>;

  return (
    <FormProvider {...methods}>
      <div className="pb-6">
        <h4 className="text-cornflower text-lg md:text-xl font-medium">
          Tell us what you think
        </h4>
        <p className="leading-relaxed text-primary-300">
          Your feedback helps us improve our docs, and product.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormInput name="href" hidden />

        <FormTextarea
          name="suggestion"
          label="Suggestion"
          placeholder="What can we do to improve this page?"
          disabled={isSubmitting}
          required
        />

        <FormInput
          name="email"
          label="Email address"
          placeholder="Your email address"
          type="email"
          disabled={isSubmitting}
          required
          validation={{
            pattern: {
              value: /^\S+@\S+$/i,
              message: 'Field is invalid',
            },
          }}
        />

        {feedbackError && (
          <FormError className="mb-2">{feedbackError}</FormError>
        )}
        <Button colour="purple" disabled={isSubmitting}>
          {isSubmitting && <LoadingSVG className="fill-current mr-2 w-6" />}
          Send Feedback
        </Button>
      </form>
    </FormProvider>
  );
};

export default FeedbackForm;
